export default __webpack_public_path__ + "static/media/menu_icon04.ad43af21.png";